import React from 'react';
import {
  PromptGroup,
  PromptItem,
  PromptItemKind,
  Account,
} from 'types/candidateStories';
import { findItemTranslation } from '../../../../../../helpers/promptGroup';
import CandidateStoryItemTextField from './CandidateStoryItemTextField';
import * as V from '../../../../../../../../../../lib/validations/candidateStoryValidations';
import ExampleList from './ExampleList';
import useT from 'hooks/useT';

const CandidateStoryPromptTextForm = ({
  promptGroup,
  disabled,
  recordId,
  account,
}: {
  promptGroup: PromptGroup | null;
  disabled: boolean;
  recordId?: string;
  account: Account;
}) => {
  const { locale: currentLanguage } = useT();

  if (disabled || !promptGroup || promptGroup.items.length === 0) {
    return null;
  }
  const exampleKeyBase =
    'components.Report.CandidateStories.Modal.GeneralInformation';
  const exampleKeys = ['example1', 'example2', 'example3', 'example4'].map(
    key => `${exampleKeyBase}.${key}`,
  );
  const interpolationValues = { company: account?.name };

  const textItems = promptGroup.items.filter(
    item => item.kind === PromptItemKind.TEXT,
  );

  if (textItems.length === 0) {
    return null;
  }

  const customValidations = [V.validateMinLength, V.maxContentLength];

  return (
    <div data-testid='candidate-story-prompt-text-form'>
      {textItems.map((item: PromptItem) => {
        const translatedItem = findItemTranslation(item, currentLanguage);
        const itemField = recordId
          ? `candidateStories.promptGroup.content.${recordId}.${item.id}`
          : `candidateStories.promptGroup.content.general.${item.id}`;
        return (
          <div
            key={item.id}
            className='mb-4'
            data-testid={`dynamic-prompt-text-section-${item.id}`}
          >
            <h5 className='mb-2'>
              {translatedItem?.title}
              {item.required && <span className='text-danger'> *</span>}
            </h5>
            {!recordId && (
              <ExampleList
                exampleKeys={exampleKeys}
                interpolationValues={interpolationValues}
              />
            )}
            <CandidateStoryItemTextField
              field={itemField}
              customValidations={item.required ? customValidations : []}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CandidateStoryPromptTextForm;
